import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const patient = {
  path: '/patients',
  component: Layout,
  name: 'patients',
  redirect: '/patients/index',
  children: [
    {
      path: '/patients/index',
      component: () => import('@/views/patient/index'),
      name: 'patients.index',
      meta: { title: i18n.t(`message.patients`)}
    },
  ]
}

export default patient